import {FC, useState, useEffect} from 'react'
import Chart from 'react-apexcharts'
import {ID} from '@/_metronic/helpers'
import {EvolutionData, EvolutionsData} from '../core/_models'
import {getEvolution} from '../core/_requests'

type Props = {
  userId?: ID
  from: Date 
  to?: Date
  height: number
}
const EvolutionChart: FC<Props> = ({userId, from, to, height}) => {
  const [data, setData] = useState<EvolutionsData>()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    const load = async () => {
      setIsLoading(true)
      try {
        const res = await getEvolution(from, to, userId)
        setData(res||[])

      } catch (e: any) {
        console.log(e)
      } finally {
        setIsLoading(false)
      }
    }
    load()
  }, [userId, from, to])

  if (isLoading) {
    return (
      <div
        className="align-items-center d-grid text-center"
        style={{minHeight: `${height}px`}}
      >
        <span>
          <i className='spinner-border fs-5x'></i>
        </span>
        
      </div>
    )
  }

  const options = {
    chart: {
      toolbar: { show: false },
      zoom: { enabled: false }
    },
    stroke: {
      width: [0, 4, 4]
    },
    xaxis: {
      type: 'datetime' as const,
      labels: {
        datetimeFormatter: {
          year: 'yyyy', // Format the year
          month: 'MMM yyyy', // Format the month
          day: 'dd MMM yyyy', // Format the day
          hour: 'HH:mm' // Format the hour
        }
      }
    },
    yaxis: [{
      title: {
        text: 'Affiliates',
      },
    }, {
      opposite: true,
      title: {
        text: 'Earnings',
      },
    }, {
      opposite: true,
      title: {
        text: 'Clicks',
      },
    }],
  dataLabels: {
    enabled: false
  },
  };

 const series = [{
    name: 'Affiliates',
    type: 'column',
    data: (data?.affiliates || []).map((d: EvolutionData) => ({x: d.date, y: d.value}))
  }, {
    name: 'Earnings',
    type: 'line',
    data: (data?.earnings || []).map((d: EvolutionData) => ({x: d.date, y: d.value}))
  }, {
    name: 'Clicks',
    type: 'line',
    data: (data?.clicks || []).map((d: EvolutionData) => ({x: d.date, y: d.value}))
  }]

  return (
    <div id="chart">
      <Chart options={options} series={series} type="line" height={height} />
    </div>
  )
}

export default EvolutionChart
